<div *ngIf="isVisible" class="modal-overlay" (click)="onBackdropClick($event)">
  <div class="modal-container" [class]="getModalClass()">
    <div class="modal-header">
      <div class="modal-icon">
        <i [class]="getIconClass()"></i>
      </div>
      <h5 class="modal-title">{{ modalConfig?.title }}</h5>
    </div>
    
    <div class="modal-body">
      <p class="modal-message">{{ modalConfig?.message }}</p>
    </div>
    
    <div class="modal-footer">
      <button 
        *ngIf="modalConfig?.showCancelButton" 
        type="button" 
        class="btn btn-outline-secondary me-2"
        (click)="onCancel()">
        {{ modalConfig?.cancelText || 'Cancel' }}
      </button>
      
      <button 
        type="button" 
        class="btn btn-primary"
        (click)="onConfirm()">
        {{ modalConfig?.confirmText || 'OK' }}
      </button>
    </div>
  </div>
</div>
